import api from '../../utils/axios';

export const getProfilingQuestions = async () => {
    try {
        const response = await api.get('/profiling/questions');
        return response.data;
    } catch (error) {
        console.error('Error fetching profiling questions:', error);
        throw error;
    }
};

export const submitProfilingAnswers = async (agentId, answers) => {
    try {
        const response = await api.post('/profiling/answers', {
            agentId,
            answers
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting profiling answers:', error);
        throw error;
    }
};
